import { PhoneCall, MessageSquare, Headphones } from "lucide-react";

// Language metadata for cards
export const LANGUAGE_META = {
  english: { icon: "🇬🇧", color: "#1d4ed8", desc: "English" },
  hinglish: { icon: "🇮🇳", color: "#f59e0b", desc: "Hinglish" },
  hindi: { icon: "🇮🇳", color: "#ea580c", desc: "Hindi" },
  tamil: { icon: "🇮🇳", color: "#0d9488", desc: "Tamil" },
  telugu: { icon: "🇮🇳", color: "#7c3aed", desc: "Telugu" },
  marathi: { icon: "🇮🇳", color: "#be123c", desc: "Marathi" },
  bengali: { icon: "🇮🇳", color: "#0891b2", desc: "Bengali" },
  kannada: { icon: "🇮🇳", color: "#059669", desc: "Kannada" },
  malayalam: { icon: "🇮🇳", color: "#65a30d", desc: "Malayalam" },
  punjabi: { icon: "🇮🇳", color: "#7c2d12", desc: "Punjabi" },
  gujarati: { icon: "🇮🇳", color: "#4338ca", desc: "Gujarati" },
  odia: { icon: "🇮🇳", color: "#a16207", desc: "Odia" },
  urdu: { icon: "🇵🇰", color: "#15803d", desc: "Urdu" },
};

export const getLanguageMeta = (value, label) =>
  LANGUAGE_META[value?.toLowerCase()] || {
    icon: "🌐",
    color: "#64748b",
    desc: label || value,
  };

export const BOT_TYPES = [
  {
    id: "call",
    label: "Call Bot",
    description: "AI voice assistant for automated phone calls with STT/TTS",
    icon: PhoneCall,
    color: "#0284c7",
  },
  {
    id: "chat",
    label: "Chat Bot",
    description: "Text-based AI assistant for chat conversations",
    icon: MessageSquare,
    color: "#059669",
  },
  {
    id: "agent-assist",
    label: "Agent Assist Bot",
    description: "AI assistant to help human agents in real-time",
    icon: Headphones,
    color: "#7c3aed",
  },
];

export const STEPS = [
  { id: "bot-type", label: "Bot Type" },
  { id: "basic-info", label: "Basic Info" },
  { id: "language-voice", label: "Language & Voice" },
  { id: "script", label: "Script & Flow" },
];
